/* eslint-disable max-len */
import React, { useEffect, useState } from 'react'
import AnimatedPage from '../../components/Animation/AnimatedPage'
import ErrorMessage from '../../components/ErrorMessage';
import Loader from '../../components/Loader';
import { validateEmail } from '../../CommonMethods/EmailValidator';

export default function LoginPage({
    setIsLoginPage,
    handleLoginCredentilas,
    email,
    password,
    emailError,
    passwordError,
    setEmailError,
    setPasswordError,
    handleLogin,
    loading,
    loginError,
    setToastErrorMessage,
    setIsForgotPassword
}) {
    const [type, settype] = useState('password')
    const [invalidEmail, setInvalidEmail] = useState(false)

    /**
     * The function "handleEmailChange" sets the state of "invalidEmail" based on the result of
     * validating the entered email.
     */
    function handleEmailChange(enteredEmail) {
        setInvalidEmail(validateEmail(enteredEmail));
    }

    useEffect(() => {
        const errorMessage = sessionStorage.getItem("errorMessage");
        if (errorMessage) {
            setToastErrorMessage(errorMessage);
            sessionStorage.removeItem("errorMessage");  // Clear the message after displaying
        }
    }, []);
    return (
        <AnimatedPage>
            <div className="w-full flex flex-col items-center h-screen shadow-s1 login-section">
                {/* <!-- login section --> */}
                <div className="mx-auto top-[15%] absolute">
                    <div className="mx-auto">
                        <img loading="lazy" src="/images/SkuTeq-Logo.svg" alt="product-logo" className="mx-auto" />
                        <p className="text-center pt-[35px] text-xl font-semibold text-[#031624] login-page-errShow">Welcome to SkuTeq</p>
                        <div className="w-[350px]">
                            <p className="pt-8 text-[#031624] text-center px-8">Please sign in using your registered Email Address and Password</p>
                            {/* <!-- error mesaage  --> */}
                            {(emailError || passwordError || invalidEmail) && <ErrorMessage error message={invalidEmail?'Invalid Email Address':loginError} />}
                            <form action="#" className="mt-[30px]" onSubmit={(e) => handleLogin(e)}>
                                <div className="flex flex-col">
                                    <label htmlFor="emailAddress" className="text-f1 font-[500] text-[#344054] pb-1.5">Email Address</label>
                                    <input
                                        type="text"
                                        id="emailAddress"
                                        onFocus={() => {
                                            setEmailError(false)
                                            setPasswordError(false)
                                            setInvalidEmail(false)
                                        }}
                                        value={email}
                                        onChange={(e) => {
                                            handleLoginCredentilas('email', e.target.value)
                                        }}
                                        onBlur={(e) => {
                                            handleEmailChange(e.target.value)
                                        }}
                                        style={{ border: `1px solid ${emailError || invalidEmail ? '#FDA29B' : '#D0D5DD'}` }}
                                        className={`w-full  rounded py-2.5 px-3.5 outline-0 placeholder:text-f2 placeholder:text-[#818E98] placeholder:font-normal text-f2 font-normal text-[#101828] `}
                                        placeholder="Enter Email Address" />
                                </div>
                                <div className="flex flex-col mt-[26px]">
                                    <label htmlFor="passWord" className="text-f1 font-[500] text-[#344054] pb-1.5">Password</label>
                                    <div className="relative">
                                        <input
                                            type={type}
                                            id="passWord"
                                            value={password}
                                            onFocus={() => {
                                                setPasswordError(false)
                                                setInvalidEmail(false)
                                                setInvalidEmail(false)
                                            }}
                                            style={{ border: `1px solid ${passwordError ? '#FDA29B' : '#D0D5DD'}` }}
                                            onChange={(e) => handleLoginCredentilas('password', e.target.value)}
                                            className="w-full border border-[#D0D5DD] rounded py-2.5 pl-3.5 pr-[39px] outline-0 placeholder:text-f2 placeholder:text-[#818E98] placeholder:font-normal text-f2 font-normal text-[#101828] err-border"
                                            placeholder="Enter Password" />
                                        <button type="button" className="cursor-pointer absolute top-[50%] -translate-y-[50%] right-2">
                                            {type === 'text' ? <img loading="lazy" src="/images/eye-open.svg" alt="password-show" className="password-show" onClick={() => settype('password')} />
                                                : <img loading="lazy" src="/images/eye-closed.svg" alt="password-hide" className="password-show" onClick={() => settype('text')} />}
                                        </button>
                                    </div>
                                </div>
                                <div class="text-end w-full mt-2">
                                    <button type='button' disabled={loading} id="forgot" onClick={() => setIsForgotPassword(true)} class="cursor-pointer text-sm font-normal text-[#106EB4]"> Forgot Password?</button>                                </div>
                                <button
                                    // onClick={()=>setIsLoginPage(false)}
                                    disabled={email === '' || password === '' || loading || invalidEmail}
                                    type="submit" id="login-form" className={`flex item-center hover:bg-[#1C8ADC] justify-center w-full ltr-spcng-8 ${loading ? 'bg-[#818E98]' : 'bg-[#106EB4]'} py-3 rounded mt-5 text-f2 font-normal text-[#ffffff] login`}>
                                    {!loading ? 'Sign in' : <span>{<Loader />}</span>}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </AnimatedPage>
    )
}
